export default "__VITE_ASSET__DvK8z6$S__"